import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'

export const StyledInfoBox = styled.div`
  display: none;
`

export const StyledBarMetricItem = styled.div<{ disabled?: boolean }>`
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  box-sizing: border-box;
  min-width: 250px;
  width: 250px;
  height: 100%;
  padding: 8px;
  margin-bottom: 8px;

  &:hover ${StyledInfoBox} {
    display: flex;
  }
`

export const StyledHeaderRow = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 2px;
`

export const StyledHeader = styled.div`
  color: ${({ theme }) => sys[theme].text.primary};
  font-weight: ${sys.fontWeight.semibold};
  font-size: ${sys.typescale[14].size};
  line-height: ${sys.typescale[14].lineHeight};
`

export const StyledIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => sys[theme].text.placeholder};
`

export const StyledCountInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`

export const StyledCountInfoBoxLeft = styled.div`
  color: ${({ theme }) => sys[theme].text.primary};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[32].size};
  line-height: ${sys.typescale[32].lineHeight};
`

export const StyledCountInfoBoxRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`

export const StyledPercentageText = styled.div`
  color: ${({ color }) => color};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[16].size};
  line-height: ${sys.typescale[16].lineHeight};
`

export const StyledBarTable = styled.div`
  display: flex;
  flex-direction: column;
`
export const StyledRowBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`

export const StyledRowTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 2px;
`

export const StyledRowTopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => sys[theme].text.primary};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[14].size};
  line-height: ${sys.typescale[14].lineHeight};
  margin-left: 2px;
`

export const StyledRowTopRight = styled.div`
  color: ${({ theme }) => sys[theme].text.primary};
  font-weight: ${sys.fontWeight.semibold};
  font-size: ${sys.typescale[14].size};
  line-height: ${sys.typescale[14].lineHeight};
`
